import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function AdminBaseSalaryManagement() {
  const [deliveryBoys, setDeliveryBoys] = useState([]);
  const [selectedBoy, setSelectedBoy] = useState("");
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [baseSalary, setBaseSalary] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- LOAD DELIVERY BOYS ---------------- */
  useEffect(() => {
    loadDeliveryBoys();
  }, []);

  /* ---------------- LOAD HISTORY ON BOY CHANGE ---------------- */
  useEffect(() => {
    if (selectedBoy) {
      loadHistory();
    }
  }, [selectedBoy]);

  /* ---------------- API CALLS ---------------- */

  const loadDeliveryBoys = async () => {
    try {
      const res = await axios.get("/admin/delivery-boys/");
      setDeliveryBoys(res.data.delivery_boys || []);
    } catch {
      setDeliveryBoys([]);
    }
  };

  const loadHistory = async () => {
    try {
      const res = await axios.get(
        `/admin/base-salary-history/?delivery_boy_id=${selectedBoy}`
      );
      setHistory(res.data.base_salary_history || []);
    } catch {
      setHistory([]);
    }
  };

  /* ---------------- SAVE BASE SALARY ---------------- */
  const handleSave = async () => {
    if (!selectedBoy || !month || !baseSalary) {
      alert("Delivery boy, month and base salary required");
      return;
    }

    setLoading(true);
    try {
      await axios.post("/admin/set-base-salary/", {
        delivery_boy_id: selectedBoy,
        month,                // YYYY-MM
        base_salary: baseSalary,
      });

      alert("Base salary saved");

      setBaseSalary("");
      loadHistory(); // refresh table
    } catch (err) {
      alert(err.response?.data?.error || "Failed to save base salary");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <h2>💼 Base Salary Management (Month-wise)</h2>

      {/* FORM */}
      <div style={card}>
        <div style={row}>
          <select
            value={selectedBoy}
            onChange={(e) => setSelectedBoy(e.target.value)}
            style={input}
          >
            <option value="">Select Delivery Boy</option>
            {deliveryBoys.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name} ({b.phone})
              </option>
            ))}
          </select>

          <input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            style={input}
          />
        </div>

        <input
          type="number"
          placeholder="Base Salary"
          value={baseSalary}
          onChange={(e) => setBaseSalary(e.target.value)}
          style={input}
        />

        <button onClick={handleSave} style={button} disabled={loading}>
          {loading ? "Saving..." : "Save Base Salary"}
        </button>
      </div>

      {/* HISTORY */}
      <h3>📜 Base Salary History</h3>

      <div style={card}>
        {history.length === 0 ? (
          <p>No records found</p>
        ) : (
          <table style={table}>
            <thead>
              <tr>
                <th>Month</th>
                <th>Base Salary</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i}>
                  <td>{h.month}</td>
                  <td>₹{h.base_salary}</td>
                  <td>{h.is_active ? "Active" : "Locked"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

/* ---------------- STYLES ---------------- */

const page = { padding: 24, background: "#f1f5f9", minHeight: "100vh" };
const card = { background: "#fff", padding: 20, borderRadius: 12, marginBottom: 16 };
const row = { display: "flex", gap: 12, marginBottom: 12 };
const input = { flex: 1, padding: "10px 12px", borderRadius: 8, border: "1px solid #cbd5e1", marginBottom: 12 };
const button = { background: "#2563eb", color: "#fff", border: "none", padding: "10px 16px", borderRadius: 8, cursor: "pointer" };
const table = { width: "100%", borderCollapse: "collapse" };
